var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomizable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 472,
    viewBox: "0 0 490 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.765 365.684L142.986 385.758L108.208 365.684L142.986 345.591L177.765 365.684Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M212.542 385.758L177.764 405.833L142.985 385.758L177.764 365.684L212.542 385.758Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M247.324 405.832L212.545 425.925L177.766 405.832L212.545 385.758L247.324 405.832Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.099 425.925L247.32 445.999L212.542 425.925L247.32 405.832L282.099 425.925Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.542 345.591L177.764 365.684L142.985 345.591L177.764 325.517L212.542 345.591Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.324 365.684L212.545 385.758L177.766 365.684L212.545 345.591L247.324 365.684Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.099 385.758L247.32 405.833L212.542 385.758L247.32 365.684L282.099 385.758Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M316.88 405.832L282.102 425.925L247.323 405.832L282.102 385.758L316.88 405.832Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.324 325.516L212.545 345.59L177.766 325.516L212.545 305.441L247.324 325.516Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M282.099 345.591L247.32 365.684L212.542 345.591L247.32 325.517L282.099 345.591Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M316.88 365.684L282.102 385.758L247.323 365.684L282.102 345.591L316.88 365.684Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M351.658 385.758L316.879 405.833L282.1 385.758L316.879 365.684L351.658 385.758Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M282.099 305.442L247.32 325.516L212.542 305.442L247.32 285.367L282.099 305.442Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.88 325.516L282.102 345.59L247.323 325.516L282.102 305.441L316.88 325.516Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M351.658 345.591L316.879 365.684L282.1 345.591L316.879 325.517L351.658 345.591Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M386.439 365.684L351.66 385.758L316.881 365.684L351.66 345.591L386.439 365.684Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M336.647 207.158C336.303 194.007 327.704 180.856 310.486 170.558C274.898 149.314 216.731 148.485 180.536 168.677C162.853 178.55 153.749 191.62 153.162 204.892C152.555 218.771 161.255 232.853 179.443 243.697C215.032 264.941 273.199 265.77 309.394 245.579C326.531 236.009 335.554 223.445 336.647 210.597",
    fill: "#00C495"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M336.647 207.158V210.597C335.554 223.445 326.531 236.009 309.394 245.579C273.199 265.77 215.032 264.941 179.443 243.697C161.255 232.853 152.555 218.771 153.162 204.892C153.749 191.62 162.853 178.55 180.536 168.677C216.731 148.485 274.898 149.314 310.486 170.558C327.704 180.856 336.303 194.007 336.647 207.158Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M275.747 260.247V209.91C275.747 195.444 283.455 182.091 295.979 174.868L368.855 131.268",
    stroke: "#0F1936",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M225.715 261.036V210.941C225.715 196.475 218.006 183.122 205.483 175.899L104.343 117.51",
    stroke: "#0F1936",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.184 160.402C161.486 160.402 168.216 153.672 168.216 145.369C168.216 137.067 161.486 130.337 153.184 130.337C144.882 130.337 138.151 137.067 138.151 145.369C138.151 153.672 144.882 160.402 153.184 160.402Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M163.078 155.304C157.647 160.736 148.852 160.781 143.365 155.439C148.797 157.021 154.902 155.687 159.191 151.398C163.466 147.123 164.805 141.047 163.25 135.629C168.554 141.119 168.497 149.885 163.078 155.304Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M211.857 191.357C217.421 191.357 221.932 186.846 221.932 181.282C221.932 175.717 217.421 171.206 211.857 171.206C206.292 171.206 201.781 175.717 201.781 181.282C201.781 186.846 206.292 191.357 211.857 191.357Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M218.269 187.718C215.077 190.926 210.084 191.238 206.528 188.646C209.911 189.188 213.495 188.162 216.122 185.551C218.732 182.957 219.767 179.397 219.245 176.03C221.783 179.564 221.449 184.521 218.269 187.718Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M295.112 189.252C301.615 189.252 306.887 183.98 306.887 177.477C306.887 170.974 301.615 165.702 295.112 165.702C288.609 165.702 283.337 170.974 283.337 177.477C283.337 183.98 288.609 189.252 295.112 189.252Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.008 182.373L300.01 182.371C303.181 179.183 304.33 174.741 303.448 170.647C306.929 174.876 306.693 181.154 302.742 185.106C298.791 189.056 292.516 189.293 288.287 185.816C292.379 186.7 296.82 185.56 300.008 182.373Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M276.213 232.225C280.147 232.225 283.335 229.036 283.335 225.103C283.335 221.17 280.147 217.981 276.213 217.981C272.28 217.981 269.092 221.17 269.092 225.103C269.092 229.036 272.28 232.225 276.213 232.225Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.827 222.636C282.808 224.873 282.377 227.588 280.542 229.436C278.714 231.278 276 231.707 273.751 230.715C275.815 230.705 277.876 229.914 279.45 228.339C281.026 226.763 281.818 224.701 281.827 222.636Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M225.713 263.929C229.646 263.929 232.835 260.74 232.835 256.807C232.835 252.874 229.646 249.686 225.713 249.686C221.78 249.686 218.591 252.874 218.591 256.807C218.591 260.74 221.78 263.929 225.713 263.929Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M231.324 254.34C232.305 256.577 231.874 259.292 230.039 261.14C228.211 262.982 225.497 263.411 223.249 262.419C225.312 262.409 227.373 261.618 228.947 260.043C230.523 258.468 231.315 256.405 231.324 254.34Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M247.322 394.426C252.887 394.426 257.398 389.915 257.398 384.35C257.398 378.785 252.887 374.274 247.322 374.274C241.758 374.274 237.247 378.785 237.247 384.35C237.247 389.915 241.758 394.426 247.322 394.426Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.974 391.714C245.357 392.256 248.941 391.23 251.568 388.62C254.179 386.025 255.213 382.464 254.691 379.097C257.234 382.633 256.911 387.59 253.717 390.784L253.715 390.786C250.523 393.995 245.53 394.306 241.974 391.714Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M247.322 352.869C252.887 352.869 257.398 348.358 257.398 342.793C257.398 337.229 252.887 332.718 247.322 332.718C241.758 332.718 237.247 337.229 237.247 342.793C237.247 348.358 241.758 352.869 247.322 352.869Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M241.974 350.158C245.357 350.7 248.941 349.674 251.568 347.063C254.179 344.468 255.213 340.908 254.691 337.54C257.234 341.076 256.911 346.033 253.717 349.228L253.715 349.229C250.523 352.438 245.53 352.75 241.974 350.158Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M391.213 275.482L281.474 212.317C267.979 204.528 251.126 214.26 251.126 229.838V272.326",
    stroke: "#0F1936",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M251.106 247.318C256.525 247.318 260.918 242.925 260.918 237.506C260.918 232.087 256.525 227.693 251.106 227.693C245.686 227.693 241.293 232.087 241.293 237.506C241.293 242.925 245.686 247.318 251.106 247.318Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M255.293 241.693L255.295 241.691C257.801 239.169 258.814 235.722 258.325 232.453C260.733 235.9 260.402 240.674 257.339 243.738C254.256 246.803 249.483 247.131 246.052 244.729C249.32 245.222 252.769 244.217 255.293 241.693Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M336.65 160.402C342.07 160.402 346.463 156.009 346.463 150.59C346.463 145.171 342.07 140.777 336.65 140.777C331.231 140.777 326.838 145.171 326.838 150.59C326.838 156.009 331.231 160.402 336.65 160.402Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M340.838 154.777L340.84 154.775C343.347 152.253 344.359 148.806 343.87 145.537C346.278 148.984 345.947 153.758 342.885 156.822C339.802 159.887 335.028 160.215 331.598 157.813C334.866 158.306 338.314 157.301 340.838 154.777Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M104.908 272.953L209.629 207.866C223.124 200.077 239.977 209.809 239.977 225.387V280.297",
    stroke: "#0F1936",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M227.611 222.555C235.142 222.555 241.247 216.45 241.247 208.919C241.247 201.387 235.142 195.282 227.611 195.282C220.08 195.282 213.975 201.387 213.975 208.919C213.975 216.45 220.08 222.555 227.611 222.555Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M236.556 217.861C231.734 222.665 224.015 222.789 219.062 218.24C223.929 219.513 229.318 218.257 233.133 214.442C236.96 210.631 238.222 205.25 236.947 200.387C241.485 205.363 241.368 213.068 236.556 217.861Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M204.894 319.952L158.542 224.274C162.872 231.315 169.852 237.951 179.462 243.677C215.051 264.92 273.218 265.75 309.413 245.558C321.309 238.922 329.402 230.87 333.53 222.251L290.152 319.931C288.331 324.423 284.366 328.672 278.215 332.111C260.896 341.782 233.017 341.377 215.981 331.201C210.498 327.923 206.816 324.018 204.914 319.931L204.894 319.952Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M176.348 237.081C181.913 237.081 186.424 232.57 186.424 227.005C186.424 221.441 181.913 216.93 176.348 216.93C170.783 216.93 166.272 221.441 166.272 227.005C166.272 232.57 170.783 237.081 176.348 237.081Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171 234.37C174.382 234.911 177.967 233.886 180.594 231.275C183.204 228.68 184.239 225.119 183.717 221.752C186.26 225.288 185.937 230.245 182.743 233.44L182.741 233.441C179.549 236.65 174.556 236.962 171 234.37Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M354.711 264.03C360.275 264.03 364.786 259.519 364.786 253.954C364.786 248.39 360.275 243.879 354.711 243.879C349.146 243.879 344.635 248.39 344.635 253.954C344.635 259.519 349.146 264.03 354.711 264.03Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M349.381 261.318C352.769 261.861 356.363 260.837 358.977 258.223C361.587 255.628 362.621 252.068 362.099 248.701C364.642 252.238 364.32 257.194 361.125 260.389L361.123 260.391C357.931 263.6 352.937 263.911 349.381 261.318Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M311.436 243.879C319.615 243.879 326.246 237.249 326.246 229.07C326.246 220.89 319.615 214.26 311.436 214.26C303.257 214.26 296.626 220.89 296.626 229.07C296.626 237.249 303.257 243.879 311.436 243.879Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M317.383 235.018C321.604 230.812 322.936 224.834 321.406 219.494L321.647 219.736C326.6 225.158 326.454 233.578 321.209 238.823C315.881 244.151 307.279 244.218 301.869 239.025C307.199 240.549 313.183 239.218 317.383 235.018Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M108.044 271.536V227.046L69.5218 204.811L31 227.046V271.536L69.5218 293.771L108.044 271.536Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M108.042 291.767L69.52 314.002V249.28L108.042 227.045V291.767Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3443 250.859L78.748 262.796V254.804L99.3443 242.888V250.859Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3443 266.012L78.748 277.949V269.957L99.3443 258.021V266.012Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5218 249.281L31 271.536V227.046L69.5218 204.811V249.281Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5218 314.002L31 291.767V227.045L69.5218 249.28V314.002Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M108.044 227.046L69.5218 249.281L31 227.046L69.5218 204.811L108.044 227.046Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0151 250.859L45.9345 254.865V246.873L39.0151 242.888V250.859Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7104 258.79L59.6298 262.796V254.804L52.7104 250.818V258.79Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0151 266.012L45.9345 270.018V262.026L39.0151 258.021V266.012Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7104 273.943L59.6298 277.949V269.957L52.7104 265.972V273.943Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M381.601 269.512V245.254L420.122 223.019L458.644 204.79V269.512L420.122 291.747L381.601 269.512Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M381.601 289.745L420.122 311.98V227.025L381.601 225.022V289.745Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M390.302 248.836L410.898 260.773V252.781L390.302 240.864V248.836Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M390.302 263.99L410.898 275.927V267.935L390.302 255.998V263.99Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M420.119 247.258L458.64 269.513V204.791L420.119 182.556V247.258Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M420.119 311.979L458.64 289.744V204.79L420.119 227.025V311.979Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M381.601 225.023L420.122 247.258L458.644 204.791L420.122 182.556L381.601 225.023Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M450.63 248.836L443.711 252.842V244.85L450.63 240.864V248.836Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 256.766L430.017 260.772V252.781L436.936 248.795V256.766Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M450.63 263.99L443.711 267.996V260.004L450.63 255.998V263.99Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M436.936 271.921L430.017 275.927V267.935L436.936 263.949V271.921Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M134.346 92.7253V48.235L95.8246 26L57.3027 28.003V92.7253L95.8246 114.96L134.346 92.7253Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M134.343 112.958L95.8208 135.193V50.2586L134.343 48.2354V112.958Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M125.645 72.0486L105.049 83.9855V75.9938L125.645 64.0771V72.0486Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M125.645 87.2019L105.049 99.1388V91.1472L125.645 79.2305V87.2019Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8246 70.4903L57.3027 92.7253V28.003L95.8246 26V70.4903Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8246 135.192L57.3027 112.957V28.0029L95.8246 50.2582V135.192Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M134.346 48.235L95.8246 50.2582L57.3027 28.003L95.8246 26L134.346 48.235Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3169 72.0486L72.2363 76.0545V68.0629L65.3169 64.0771V72.0486Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0132 79.9995L85.9325 83.9852V75.9935L79.0132 72.0078V79.9995Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3169 87.2019L72.2363 91.2078V83.2162L65.3169 79.2305V87.2019Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0132 95.1528L85.9325 99.1385V91.1469L79.0132 87.1611V95.1528Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M339.114 108.911V64.4206L377.636 42.1855L416.158 64.4206V108.911L377.636 131.146L339.114 108.911Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M339.114 129.142L377.636 151.377V86.6752L339.114 64.4199V129.142Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M347.815 88.2341L368.412 100.171V92.1794L347.815 80.2627V88.2341Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M347.815 103.387L368.412 115.324V107.333L347.815 95.416V103.387Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M377.636 86.6758L416.158 108.911V64.4206L377.636 42.1855V86.6758Z",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M377.636 151.377L416.158 129.142V64.4199L377.636 86.6752V151.377Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M339.114 64.4206L377.636 86.6758L416.158 64.4206L377.636 42.1855L339.114 64.4206Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M408.147 88.2341L387.53 100.171V92.1794L408.147 80.2627V88.2341Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M408.147 103.387L387.53 115.324V107.333L408.147 95.416V103.387Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M134.345 261.076C138.279 261.076 141.467 257.888 141.467 253.955C141.467 250.021 138.279 246.833 134.345 246.833C130.412 246.833 127.224 250.021 127.224 253.955C127.224 257.888 130.412 261.076 134.345 261.076Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M139.956 251.488C140.938 253.725 140.507 256.44 138.672 258.288C136.844 260.13 134.13 260.558 131.881 259.567C133.945 259.557 136.006 258.765 137.58 257.191C139.156 255.615 139.948 253.553 139.956 251.488Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizable);
export default __webpack_public_path__ + "static/media/customizable.5359f111dd2bfe4142dcc6dacdbe193a.svg";
export { ForwardRef as ReactComponent };